import { render } from "./Datefield.vue?vue&type=template&id=2da72f2e&lang=html"
import script from "./Datefield.vue?vue&type=script&lang=js"
export * from "./Datefield.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__